var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GoogleMapMarker',{attrs:{"google":_vm.google,"map":_vm.map,"options":_vm.options},on:{"click":_vm.handleMarkerClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }